const a = [
  "163",
  "abv",
  "alice",
  "aliyun",
  "aol",
  "arnet",
  "att",
  "bellsouth",
  "blueyonder",
  "btinternet",
  "charter",
  "comcast",
  "cox",
  "daum",
  "earthlink",
  "fastmail",
  "fibertel",
  "freeserve",
  "games",
  "globo",
  "globomail",
  "gmail",
  "gmx",
  "googlemail",
  "hanmail",
  "hotmail",
  "hush",
  "hushmail",
  "icloud",
  "iname",
  "inbox",
  "itelefonic",
  "juno",
  "laposte",
  "lavabit",
  "libero",
  "list",
  "live",
  "mac",
  "mail",
  "me",
  "msn",
  "nate",
  "naver",
  "neuf",
  "ntlworld",
  "o2",
  "oi",
  "online",
  "outlook",
  "pobox",
  "poste",
  "prodigy",
  "proonmail",
  "protonmail",
  "qq",
  "r7",
  "rambler",
  "rocketmail",
  "safe-mail",
  "sbcglobal",
  "sina",
  "skynet",
  "speedy",
  "t-online",
  "talktalk",
  "telenet",
  "teletu",
  "terra",
  "tin",
  "tiscali",
  "tvcablenet",
  "uol",
  "verizon",
  "virgilio",
  "virgin",
  "virginmedia",
  "voo",
  "wanadoo",
  "web",
  "wow",
  "ya",
  "yahoo",
  "yandex",
  "ygm",
  "ymail",
  "zipmail",
  "zoho"
];
export {
  a as default
};
